import React from "react";
import "../stylesheets/footer.css";

const Footer = () => {
  return (
    <section id="footer">
      <h4>Designed & Built by Ysabella Panghulan</h4>
    </section>
  );
};

export default Footer;
